import App from './App'
import "src/assets/scss/main.scss"

import { Route, createBrowserRouter, createRoutesFromElements } from 'react-router-dom'
import EditLecture from './coursepart/Lecture/EditLecture'
import coursePartService from './coursepart/CoursePartService'
import Lectures from './coursepart/Lecture/Lectures'
import PartInfo from './coursepart/PartInfo'
import Links from './coursepart/Link/Links'
import Files from './coursepart/File/Files'
import Tests from './coursepart/Test/Tests'
import lectureService from './coursepart/Lecture/LectureService'
import lecturePlayerService from './coursepart/Lecture/Player/LecturePlayerService'
import LecturePlayer from './coursepart/Lecture/Player/LecturePlayer'
import screenEditService from './coursepart/Lecture/Player/ScreenAudioEditService'
import AudioEditor from './coursepart/Lecture/Player/waveEdit/AudioEditor'
import AllCourseparts from './coursepart/AllCourseparts'
import coursePartCollectionService from './coursepart/CoursePartCollectionService'
import EditTest from './coursepart/Test/EditTest'
import testService from './coursepart/Test/TestService'
import { ErrorBoundary } from './components/ErrorBoundary'
import Publish from './coursepart/Publish/Publish'
import Evaluations from './coursepart/Evaluations/Evaluations'
import CoursePartGeneral from './coursepart/General/General'
import courseCollectionService from './course/CourseCollectionService'
import FindCourses from './course/FindCourses/FindCourses'
import courseService from './course/CourseService'
import CourseComponent from './course/CourseComponent'
import CourseGeneral from './course/CourseGeneral'
import CoursePublish from './course/Publish/CoursePublish'
import EditTheme from './course/Theme/EditTheme'
import CoursePartStart from './coursepart/CoursePartStart'
import PrintPart from './coursepart/Print/PrintPart'
import PrintCourse from './course/PrintCourse'
import Home from './Home/Home'
import SwitchUser from './login/SwitchUser'
import CourseAddons from './course/CourseAddons/CourseAddons'
import LecturesDiff from './coursepart/Lecture/Diff/LecturesDiff'
import ViewLectureDiff from './coursepart/Lecture/Diff/ViewLectureDiff'
import FilesDiffMain from './coursepart/File/Diff/FilesDiffMain'
import LinksDiffMain from './coursepart/Link/Diff/LinksDiffMain'
import TestDiffMain from './coursepart/Test/Diff/TestDiffMain'
import DiffOneTest from './coursepart/Test/Diff/DiffOneTest'
import Diploma from './course/Diploma/Diploma'
import AllCourses from './course/FindCourses/AllCourses'
import CourseFindByStudentClass from './course/FindCourses/CourseFindByStudentClass'





const lectureLoader = async (partId: string, lectureId: string, getDeleted: boolean) => {
    return lectureService.getLectureData(lectureId, getDeleted)
}

const lecturePlayLoader = async (partId: string, lectureId: string, num: number, getDeleted: boolean) => {
    return lecturePlayerService.setCurrentLecture(lectureId, num);
}

const screenEditLoader = async (lectureId: string, screenId: string) => {
    await lectureService.setScreenWithAudioEditing( lectureId , screenId);
    return await screenEditService.fetchAudio(screenId, lectureId);
}

const recordingEditLoader = async ( lectureId: string, screenId: string) => {
    const result = await lectureService.setScreenWithNewRecording( lectureId , screenId);
    requestAnimationFrame(() => {
        screenEditService.markRecordingReady();
    });
    return result;
}

const testLoader = async (partId: string, testId: string) => {
    return testService.getTestData(partId, testId);
}

const testDiffLoader = async (partId: string, testId: string) => {
    return testService.getTestDiffData(partId, testId);
}

async function courseLoader(courseId: string, partLoader: () => Promise<any>) {
    await courseService.loadCourse(courseId);
    return partLoader()
}

const lecturesRouter =
    <>
        <Route path="lectures" element={<Lectures />} >
            <Route loader={({ params }) => lectureLoader(params.partId!, params.lectureId!, false)} path=":lectureId" element={<EditLecture />} >
                <Route loader={({ params }) => lecturePlayLoader(params.partId!, params.lectureId!, +params.num!, false)} path=":num/:playtype/" element={<LecturePlayer />} >
                    <Route loader={({ params }) => screenEditLoader(params.lectureId!, params.screenId!)} path=":screenId/edit" element={<AudioEditor />} />
                    <Route loader={({ params }) => recordingEditLoader(params.lectureId!,params.screenId!)} path=":screenId/editRecording" element={<AudioEditor />} />
                </Route>

            </Route>


        </Route>
        <Route path="lecturesdiff" loader={({ params }) => coursePartService.getDiffLectures(params.partId!)} element={<LecturesDiff />} />
        <Route loader={({ params }) => lectureLoader(params.partId!, params.lectureId!, true)} path="lecturesdiff/:lectureId" element={<ViewLectureDiff />} />
        <Route loader={({ params }) => lecturePlayLoader(params.partId!, params.lectureId!, +params.num!, true)} path="lecturesdiff/:lectureId/:num/:playtype/" element={<LecturePlayer />} />

    </>;

const partsRouter = <>
    <Route index path="" element={<PartInfo />} />
    <Route index path="texts" element={<PartInfo />} />
    {lecturesRouter}


    <Route path="links" element={<Links />} />
    <Route path="linksDiff" element={<LinksDiffMain />} loader={({ params }) => coursePartService.getDiffLinks(params.partId!)} />

    <Route path="files" element={<Files />} />
    <Route path="filesDiff" element={<FilesDiffMain />} loader={({ params }) => coursePartService.getDiffFiles(params.partId!)} />

    <Route path="tests" element={<Tests />} >
        <Route loader={({ params }) => testLoader(params.partId!, params.testId!)} path=":testId/:type" element={<EditTest />} />
    </Route>
    <Route path="testsDiff" element={<TestDiffMain />} loader={({ params }) => coursePartService.getDiffTests(params.partId!)}>
        <Route loader={({ params }) => testDiffLoader(params.partId!, params.testId!)} path=":testId/:type" element={<DiffOneTest />} />
    </Route>

    <Route path="evaluations" element={<Evaluations />} />
    <Route path="general" element={<CoursePartGeneral />} />
    <Route path="print" element={<PrintPart />} />
    <Route path="publish" element={<Publish />} />
</>;


export const router = createBrowserRouter(
    createRoutesFromElements(
        <>
            <Route path="/" element={<App />} errorElement={<ErrorBoundary />}> 

                <Route index element={<Home />} />
                <Route path="switchuser" element={<SwitchUser />} />

                <Route loader={({ params }) => coursePartService.loadPart({ partId: params.partId!, forceReload: true })} shouldRevalidate={({ currentParams, nextParams }) => currentParams.partId !== nextParams.partId} path="coursepart/:partId" element={<CoursePartStart />} >
                    {partsRouter}
                </Route>

                <Route loader={({ params }) => courseService.loadCourse(params.courseId!)} path="course/:courseId/" element={<CourseComponent />} >
                    <Route index path="general" element={<CourseGeneral />} />
                    <Route path="publish" element={<CoursePublish />} />
                    <Route path="diploma" element={<Diploma />} />
                    <Route path="print" element={<PrintCourse />} />
                    <Route path="addons" element={<CourseAddons />} />
                    <Route path="content/:themeId" loader={() => { coursePartService.purgePartOpenFromCourse(); return null; }} element={<EditTheme />} />
                </Route>

                <Route path="course/:courseId/content/:themeId/:partId" loader={({ params }) => courseLoader(params.courseId!, () => coursePartService.loadPart({ partId: params.partId!, openFromCourse: true }))} element={<CoursePartStart />} >
                    {partsRouter}
                </Route>


                <Route loader={() => coursePartCollectionService.fetchCourseParts("", true)} path="/allparts" element={<AllCourseparts />} />
                <Route loader={() => courseCollectionService.getCourses(true)} path="/findcourses" element={<FindCourses />} >
                    <Route index element={<AllCourses />} />
                    <Route path="all" element={<AllCourses />} />
                    <Route path="byclass" element={<CourseFindByStudentClass />} />
                </Route>



            </Route>
            <Route path="login" element={<App />} />
            <Route path="*" element={<App />} /> {/* Catch-all route for 404 */}
        </>



    )
);

router.subscribe((state, opts) => {

    if (state.navigation.state === "idle") {

        if (state.matches[0].params["courseId"]) {
            // set last url for the part, in order to get to the right tab when switching between parts
            const courseId = state.matches[0].params["courseId"];
            const url = state.location.pathname;
            courseService.setDataUrl(courseId, url);

        } else if (state.matches[0].params["partId"]) {

            //courseService.clearCurrentCourseId();
            // set last url for the part, in order to get to the right tab when switching between parts
            const partId = state.matches[0].params["partId"];
            const url = state.location.pathname;
            coursePartService.setDataUrl(partId, url);
        }
        else {
            courseService.clearCurrentCourseId();
        }

    }

})

const navigateTo = (url: string) => {
    if (router) {
        router.navigate(url);
    }
}

const _navigate = router.navigate.bind(router);

type Listener = () => boolean | Promise<boolean>;
const listeners: Listener[] = [];

router.navigate = async (...args) => {
    const params = args as [any];

    if (listeners.length > 0) {
        const promises = listeners.map((fn) => fn());
        const values = await Promise.all(promises);
        const allowed = values.every(Boolean);

        if (!allowed) return;
    }

    return _navigate(...params);
};

courseService.setNavigator(navigateTo);








